import React from "react";
import GlobalTheme from "../../../styles/global.theme";
import * as Styled from "./Buttons.styled.js";
import * as MUIStyled from "../../../MUIStyled.js";

import { FaArrowLeft } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

export const ButtonPurple = ({ type, onClick, children, style, disabled }) => {
    return (
        <Styled.ButtonPurple
            type={type}
            onClick={onClick}
            disabled={disabled}
            style={style}>
            {children}
        </Styled.ButtonPurple>
    );
};

export const ButtonPurpleNext = ({
    type,
    onClick,
    disabled,
    children,
    style,
}) => {
    return (
        <Styled.ButtonPurpleNext
            type={type}
            onClick={onClick}
            disabled={disabled}
            style={style}>
            {children}
        </Styled.ButtonPurpleNext>
    );
};

export const ButtonText = ({ type, onClick, children, style }) => {
    return (
        <Styled.TextButton
            type={type}
            onClick={onClick}
            style={style}>
            {children}
        </Styled.TextButton>
    );
};

export const ButtonSubmit = ({ type, onClick, children, style }) => {
    return (
        <Styled.SubmitButton
            type={type}
            onClick={onClick}
            style={style}>
            {children}
        </Styled.SubmitButton>
    );
};

export const BackButton = ({ onClick, sx }) => {
    return (
        <MUIStyled.CustomIconArrowButton
            onClick={onClick}
            sx={sx}>
            <FaArrowLeft
                style={{
                    fontSize: "24px",
                    color: GlobalTheme.palette.black.primary.main,
                }}
            />
        </MUIStyled.CustomIconArrowButton>
    );
};

export const CloseButton = ({ onClick, style, sx, pageContext, ...props }) => {
    return (
        <MUIStyled.CustomIconButton
            aria-label="close"
            onClick={onClick}
            sx={{
                color: GlobalTheme.palette.black.primary.main,
                ...sx,
            }}
            style={style}
            {...props}>
            <IoClose />
        </MUIStyled.CustomIconButton>
    );
};

export const DeleteButton = ({ onClick, variant, children }) => {
    return (
        <MUIStyled.CustomButton
            onClick={onClick}
            variant={variant}
            sx={{
                fontSize: "16px",
                padding: "10px",
                textTransform: "none",
                color: `${GlobalTheme.palette.pink.primary.main}`,
                border:
                    variant === "outlined"
                        ? `1px solid ${GlobalTheme.palette.pink.primary.main}`
                        : "none",
                "@media (max-width:600px)": {
                    padding: "5px",
                },
            }}>
            {children}
        </MUIStyled.CustomButton>
    );
};
